import { h } from "../core/dom.js";
import { icon } from "../lib/icons.js";
import { api } from "../api.js";
import { openModal, toast } from "./ui.js";

// User-facing abuse reporting. `openReportModal` pops a small form (reason + optional
// details) for a target; `reportButton` is the ghost link to drop onto a public screen.

const REASONS = [
  "Spam or advertising",
  "Inappropriate or offensive",
  "Misleading or unsafe advice",
  "Impersonation",
  "Other",
];

const TYPE_LABEL = { workout: "workout", program: "program", user: "user", exercise: "exercise" };

export function openReportModal({ targetType, targetId, name }) {
  let reason = REASONS[0];
  let details = "";

  const reasonSelect = h(
    "select",
    { class: "input", onchange: (e) => (reason = e.target.value) },
    ...REASONS.map((r) => h("option", { value: r }, r))
  );
  const detailsInput = h("textarea", {
    class: "input",
    rows: 3,
    placeholder: "Anything else we should know? (optional)",
    oninput: (e) => (details = e.target.value),
  });

  const submit = async () => {
    m.close();
    try {
      await api.report({ target_type: targetType, target_id: targetId, reason, details: details.trim() || undefined });
      toast("Thanks — report sent to the moderators", "success");
    } catch (e) {
      toast(e.message, "error");
    }
  };

  const m = openModal({
    title: `Report this ${TYPE_LABEL[targetType] || "content"}`,
    className: "modal-confirm",
    content: h(
      "div",
      null,
      name ? h("p", { class: "dim", style: { marginTop: 0 } }, name) : null,
      h("div", { class: "field" }, h("label", null, "Reason"), reasonSelect),
      h("div", { class: "field" }, h("label", null, "Details"), detailsInput),
      h(
        "div",
        { class: "btn-row mt" },
        h("button", { class: "btn btn-ghost", onClick: () => m.close() }, "Cancel"),
        h("button", { class: "btn btn-danger grow", onClick: submit }, icon("flag", { size: 16 }), "Send report")
      )
    ),
  });
}

/** A subtle "Report" ghost button for public content screens. */
export function reportButton({ targetType, targetId, name }) {
  return h(
    "button",
    {
      class: "btn btn-ghost",
      style: { fontSize: ".8rem", padding: "6px 12px", color: "var(--text-3)" },
      onClick: () => openReportModal({ targetType, targetId, name }),
    },
    icon("flag", { size: 14 }),
    "Report"
  );
}
